export function countChestsByType(chests) {
  const counts = {};

  for (const type of chests || []) {
    counts[type] = (counts[type] || 0) + 1;
  }

  return Object.entries(counts).map(([type, count]) => ({type, count}));
}
